import React from 'react';
import logo from 'assets/img/brand/company_logo.png';
import { moneyFormatter } from 'utli';
import './printStyle.scss';
import moment from 'moment';

class CustomDutyInvoicePrintComponent extends React.Component {
  
  // Helper method to render header section
  renderHeader = (pageNumber = null, totalPages = null) => (
    <div className='print-header'>
      <div className='header-row'>
        <div className='logo-section'>
          <div className='logo-wrapper'>
            <img src={logo} alt='Company Logo' className='company-logo' />
            <div className='company-info'>
              <p className='company-name'>EASTY FREIGHT INTERNATIONAL LOGISTICS COMPANY LIMITED</p>
              <p className='company-address'>[No.47, May Kha Street, May Kha Housing, Thingangyun Twsp, Yangon]</p>
            </div>
          </div>
        </div>
        <div className='invoice-title'>
          <h1>COMMERCIAL INVOICE</h1>
          <h3>[ Import/Export Duty ]</h3>
          {pageNumber && totalPages && (
            <p style={{ fontSize: '12px', marginTop: '10px' }}>
              Page {pageNumber} of {totalPages}
            </p>
          )}
        </div>
      </div>
      <div className='header-border'></div>
    </div>
  );

  // Helper method to render info sections (only on first page)
  renderInfoSections = (data) => (
    <>
      {/* Date and Sale Person */}
      <div className='info-row'>
        <table className='info-table'>
          <tbody>
            <tr>
              <td className='label-cell'>Date</td>
              <td className='value-cell'>{data?.invoice_date ? moment(data.invoice_date).format('DD-MMM-YYYY') : '-'}</td>
            </tr>
            <tr>
              <td className='label-cell'>Sale Person</td>
              <td className='value-cell'>{data?.sale_person?.name || '-'}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Customer and Deposit Information */}
      <div className='main-info-section'>
        <div className='customer-info'>
          <h3 className='section-title'>Customer Information</h3>
          <div className='info-item'>
            <span className='label'>Customer Name</span>
            <span className='value'>{data?.receiver?.name || '-'}</span>
          </div>
          <div className='info-item'>
            <span className='label'>Customer Code</span>
            <span className='value'>{data?.address_code || '-'}</span>
          </div>
          <div className='info-item'>
            <span className='label'>Customer Address</span>
            <span className='value'>{data?.receiver?.address || '-'}</span>
          </div>
          <div className='info-item'>
            <span className='label'>Contact Phone No.</span>
            <span className='value'>{data?.receiver?.phone || '-'}</span>
          </div>
        </div>

        <div className='deposit-info'>
          <div className='deposit-info-container'>
            <h3 className='section-title'>Invoice Information</h3>
            <div className='info-item'>
              <span className='label'>Invoice No.</span>
              <span className='value'>{data?.invoice_number || '-'}</span>
            </div>
            <div className='info-item'>
              <span className='label'>Import Duty No.</span>
              <span className='value'>{data?.id_no || '-'}</span>
            </div>
            <div className='info-item'>
              <span className='label'>Waybill No.</span>
              <span className='value' style={{ color: "black" }}>{data?.waybill_number || '-'}</span>
            </div>
            <div className='info-item'>
              <span className='label'>License No.</span>
              <span className='value'>{data?.license_no || '-'}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  // Helper method to render table header
  renderTableHeader = () => (
    <thead>
      <tr>
        <th rowSpan='1' style={{ verticalAlign: 'middle', width: '40px' }}>SR<br />NO</th>
        <th rowSpan='1' style={{ verticalAlign: 'middle', width: '180px' }}>COMMODITY</th>
        <th rowSpan='1' style={{ verticalAlign: 'middle', width: '60px' }}>UNIT</th>
        <th rowSpan='1' style={{ verticalAlign: 'middle', width: '50px' }}>QTY</th>
        <th rowSpan='1' style={{ verticalAlign: 'middle', width: '120px' }}>IMPORT LICENCE COMMODITY<br />VALUE/UNIT (MMK)</th>
        <th rowSpan='1' style={{ verticalAlign: 'middle', width: '100px' }}>TAX AMOUNT<br />(EXCL TAX)</th>
        <th rowSpan='1' style={{ verticalAlign: 'middle', width: '100px' }}>DOCUMENT/<br />SERVICE FEE</th>
        <th rowSpan='1' style={{ verticalAlign: 'middle', width: '100px' }}>TOTAL AMOUNT<br />(MMK)</th>
      </tr>
    </thead>
  );

  // Helper method to render bank information (only on last page)
  renderBankInformation = () => (
    <div className='bank-section'>
      <h3 className='section-title'>Bank Information for Payment</h3>
      <table className='bank-table'>
        <thead>
          <tr>
            <th className='sr-col'>Sr.</th>
            <th className='bank-name-col'>Bank Name</th>
            <th className='account-name-col'>Account Name</th>
            <th className='account-number-col'>Account Number</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>KBZ-BANK</td>
            <td>U SOE MIN ZAW</td>
            <td>0275 110 3800 226 801</td>
          </tr>
          <tr>
            <td>2</td>
            <td>YOMA-BANK</td>
            <td>U SOE MIN ZAW</td>
            <td>000 345 480 000 813</td>
          </tr>
          <tr>
            <td>3</td>
            <td>CB-BANK</td>
            <td>U SOE MIN ZAW</td>
            <td>0003 1009 0000 9938</td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  // Helper method to render signatures (only on last page)
  renderSignatures = () => (
    <div className='signature-section' style={{ marginTop: "155px" }}>
      <div className='signature-box'>
        <p className='signature-title'>Received By / Customer</p>
        <div className='signature-line'></div>
        <p className='signature-label'>Signature</p>
        <p className='signature-label'>Name</p>
      </div>
      <div className='signature-box'>
        <p className='signature-title'>Checked By / Finance</p>
        <div className='signature-line'></div>
        <p className='signature-label'>Signature</p>
        <p className='signature-label'>Name</p>
      </div>
      <div className='signature-box'>
        <p className='signature-title'>Verified By / Sales</p>
        <div className='signature-line'></div>
        <p className='signature-label'>Signature</p>
        <p className='signature-label'>Name</p>
      </div>
    </div>
  );

  render() {
    const { data } = this.props;

    if (!data) return null;

    // Calculate total amount from items total_amount
    const totalAmount = data?.items?.reduce((sum, item) => sum + (parseFloat(item.total_amount) || 0), 0) || 0;
    
    const items = data?.items || [];
    const itemsPerPage = 25;
    const totalPages = Math.ceil(items.length / itemsPerPage);
    
    console.log('Pagination Debug:', {
      totalItems: items.length,
      itemsPerPage,
      totalPages,
      willPaginate: items.length > itemsPerPage
    });
    
    // If items are 25 or less, render single page
    if (items.length <= itemsPerPage) {
      return (
        <div className='custom-duty-invoice-print'>
          {this.renderHeader()}
          {this.renderInfoSections(data)}
          
          {/* Duty & Service Details */}
          <div className='service-section'>
            <h3 className='section-title'>Duty & Service Details</h3>
            <table className='items-table'>
              {this.renderTableHeader()}
              <tbody>
                {items.length > 0 ? (
                  <>
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: 'center' }}>{index + 1}</td>
                        <td style={{ textAlign: 'left' }}>{item.commodity || '-'}</td>
                        <td style={{ textAlign: 'center' }}>{item.unit || '-'}</td>
                        <td style={{ textAlign: 'center' }}>{item.qty || '-'}</td>
                        <td style={{ textAlign: 'right' }}>{item.import_licence_commodity_value_unit ? moneyFormatter(Math.round(item.import_licence_commodity_value_unit)) : '-'}</td>
                        <td style={{ textAlign: 'right' }}>{item.tax_amount_excl_tax ? moneyFormatter(item.tax_amount_excl_tax) : '-'}</td>
                        <td style={{ textAlign: 'right' }}>{item.doc_service_fee ? moneyFormatter(item.doc_service_fee) : '-'}</td>
                        <td style={{ textAlign: 'right' }}>{item.total_amount ? moneyFormatter(item.total_amount) : '-'}</td>
                      </tr>
                    ))}
                    {/* Sub Total Row */}
                    <tr className='total-row subtotal-row'>
                      <td colSpan='7' className='total-label'>SUB TOTAL</td>
                      <td className='total-amount'>{moneyFormatter(totalAmount)}</td>
                    </tr>
                  </>
                ) : (
                  <tr>
                    <td colSpan='8' className='center'>No items</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          
          {this.renderBankInformation()}
          {this.renderSignatures()}
        </div>
      );
    }

    // Multiple pages rendering
    const pages = [];
    for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
      const startIndex = pageIndex * itemsPerPage;
      const endIndex = Math.min(startIndex + itemsPerPage, items.length);
      const pageItems = items.slice(startIndex, endIndex);
      const isFirstPage = pageIndex === 0;
      const isLastPage = pageIndex === totalPages - 1;
      
      console.log(`Creating page ${pageIndex + 1}:`, {
        pageIndex,
        startIndex,
        endIndex,
        pageItemsCount: pageItems.length,
        isFirstPage,
        isLastPage
      });

      pages.push(
        <div key={pageIndex} className={`custom-duty-invoice-print ${!isLastPage ? 'page-break' : ''}`}>
          {this.renderHeader(pageIndex + 1, totalPages)}
          
          {/* Only show info sections on first page */}
          {isFirstPage && this.renderInfoSections(data)}
          
          {/* Duty & Service Details */}
          <div className='service-section'>
            <h3 className='section-title'>Duty & Service Details {!isFirstPage && `(Continued)`}</h3>
            <table className='items-table'>
              {this.renderTableHeader()}
              <tbody>
                {pageItems.map((item, index) => (
                  <tr key={startIndex + index}>
                    <td style={{ textAlign: 'center' }}>{startIndex + index + 1}</td>
                    <td style={{ textAlign: 'left' }}>{item.commodity || '-'}</td>
                    <td style={{ textAlign: 'center' }}>{item.unit || '-'}</td>
                    <td style={{ textAlign: 'center' }}>{item.qty || '-'}</td>
                    <td style={{ textAlign: 'right' }}>{item.import_licence_commodity_value_unit ? moneyFormatter(Math.round(item.import_licence_commodity_value_unit)) : '-'}</td>
                    <td style={{ textAlign: 'right' }}>{item.tax_amount_excl_tax ? moneyFormatter(item.tax_amount_excl_tax) : '-'}</td>
                    <td style={{ textAlign: 'right' }}>{item.doc_service_fee ? moneyFormatter(item.doc_service_fee) : '-'}</td>
                    <td style={{ textAlign: 'right' }}>{item.total_amount ? moneyFormatter(item.total_amount) : '-'}</td>
                  </tr>
                ))}
                
                {/* Show subtotal only on last page */}
                {isLastPage && (
                  <tr className='total-row subtotal-row'>
                    <td colSpan='7' className='total-label'>SUB TOTAL</td>
                    <td className='total-amount'>{moneyFormatter(totalAmount)}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          
          {/* Only show bank info and signatures on last page */}
          {isLastPage && (
            <>
              {this.renderBankInformation()}
              {this.renderSignatures()}
            </>
          )}
        </div>
      );
    }

    console.log('Total pages created:', pages.length);

    return (
      <div className="multi-page-container">
        {pages}
      </div>
    );
  }
}

export default CustomDutyInvoicePrintComponent;
